import { Typography, styled } from '@mui/material'
import React from 'react'

const TypographyCC = styled(Typography)({
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
})

const TypographyEllipsis = ({children, ...props}) => {
    return (
        <TypographyCC {...props}>{children}</TypographyCC>
    )
}

export default TypographyEllipsis